import React, { useEffect, useState } from 'react';
import { MDBTable, MDBTableBody } from 'mdbreact';
import { useLanguage } from '../../context/language';
import { getStrLang } from '../Translate';
import { useHistory, useLocation } from 'react-router-dom';
import { MDBContainer, MDBBtn as MDBTN, MDBModal, MDBModalBody, MDBModalHeader, MDBModalFooter } from 'mdbreact';

const ReturnInfoWithdrawl = (props) => {
    //utilizando o contexto
    const { lang, setOrderFromRetirada } = useLanguage();
    
    //Acessando informações da rota
    const history = useHistory();
    const location = useLocation();
    //hooks
    const [modal, setModal] = useState(false);

    //Modifica o status do modal de termos, se deve aparecer ou não
    const toggle = () => {
        setModal(!modal)
    }

    let data_return = {
        columns: [
            {
                field: 'campo',
                sort: 'asc',
            },
            {
                field: 'valor',
                sort: 'asc'
            }
        ],
        rows: [
            {
                'campo': getStrLang(lang.nameLang, "ordem_num"),
                'valor': props.infoApi.ordem
            },
            /*
            {
                'campo': getStrLang(lang.nameLang, "date_table"),
                'valor': props.infoApi.dt_criacao
            },
            {
                'campo': getStrLang(lang.nameLang, "atuz_table"),
                'valor': props.infoApi.dt_atualizacao
            },
            */
            {
                'campo': getStrLang(lang.nameLang, "status_"),
                'valor': getStrLang(lang.nameLang, props.infoApi.status)
            },
            /*
            {
                'campo': getStrLang(lang.nameLang, "client_table"),
                'valor': props.infoApi.cliente
            },
            {
                'campo': getStrLang(lang.nameLang, "pais_table"),
                'valor': props.infoApi.pais
            },
            */
            {
                'campo': getStrLang(lang.nameLang, "value_table"),
                'valor': props.infoApi.amount
            },
            {
                'campo': getStrLang(lang.nameLang, "value_convert_table"),
                'valor': props.infoApi.conv_amount
            },
            {
                'campo': getStrLang(lang.nameLang, "tx_cambio_table"),
                'valor': props.infoApi.rate
            },
            {
                'campo': getStrLang(lang.nameLang, "nome_banck"),
                'valor': props.infoApi.bank_name
            },
            {
                'campo': getStrLang(lang.nameLang, "agenc_banck"),
                'valor': props.infoApi.bank_branch
            },
            {
                'campo': getStrLang(lang.nameLang, "nu_conta"),
                'valor': props.infoApi.account_no
            },
            {
                'campo': getStrLang(lang.nameLang, "tp_conta"),
                'valor': props.infoApi.account_type
            },
            {
                'campo': getStrLang(lang.nameLang, "date_convert"),
                'valor': formatDataAPI(props.infoApi.rate_updated)
            }
        ]
    };

    //Função que ajusta datas para mostrar na tela
    function formatDataAPI(data) {
        if (data && data.toString().length > 18) {
            return data.substring(0, 10) + " " + data.substring(11, 19);
        } else {
            return data;
        }

    }

    return (
        <div className="info-withdrawl">
            <div className="info-withdrawl-title">
                <h4 data-lang-str="solict_ret"> </h4>
            </div>
            <MDBTable striped>
                <MDBTableBody rows={data_return.rows} />
            </MDBTable>
            <MDBContainer>
                <MDBModal isOpen={modal} toggle={toggle}>
                    <MDBModalHeader toggle={toggle}>{props.mensagem.msg1}</MDBModalHeader>
                    <MDBModalBody>
                        <p>{props.mensagem.msg2}<br/>{props.mensagem.msg3}</p>
                    </MDBModalBody>
                    <MDBModalFooter>
                        <MDBTN color="primary" onClick={() => {history.push("/404")}}>{getStrLang(lang.nameLang, "btn_fechar")}</MDBTN>
                    </MDBModalFooter>
                </MDBModal>
            </MDBContainer>
        </div>
    );
};

export default ReturnInfoWithdrawl;